import type { ActiveID, SetActiveAnnotationAction } from './types';
import { ActiveAnnotationActionEnum } from './types';

export const activeAnnotationReducer = (
  id: ActiveID,
  action: SetActiveAnnotationAction
): ActiveID => {
  switch (action.type) {
    case ActiveAnnotationActionEnum.setActiveAnnotation:
      return action.payload.id;
    default:
      return id;
  }
};
